/**************************************************
 * Nombre:       Tarjeta_Contacto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";

const Tarjeta_Contacto = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.icon} width={'70%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 9}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{
                        fontSize: 26,
                        fontFamily: NEGRITA,
                        fontWeight: 600,
                        lineHeight: 1.1
                    }}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400, height: 50}}>{item.descripcion}</Typography>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Contacto